<div class="appraisals-list-container">

  <!-- Header -->
  <div class="list-header">
    <div class="header-title">
      <h3>
        <i class="fa list-title-icon" [ngClass]="listTitleIconClass" aria-hidden="true"></i>
        <span>{{ listTitleKey | translate }}</span>
      </h3>
      <span class="record-count">{{ totalItems }} {{ 'RECORDS' | translate }}</span>
    </div>
    <div class="header-actions">
      <button
        *ngIf="canCreateAppraisal && !(hasActiveStatusFilter && totalItems === 0)"
        class="btn btn-success appraisal-create-btn"
        (click)="createAppraisal()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span translate>NEW_APPRAISAL</span>
      </button>
    </div>
  </div>

  <!-- Archive View -->
  <div
    *ngIf="isManager"
    class="archive-view-bar"
    style="display: flex; align-items: center; margin-bottom: 14px;"
  >
    <div
      class="archive-view-toggle"
      role="group"
      [attr.aria-label]="'APPRAISAL_ARCHIVE_FILTER' | translate"
      style="display: inline-flex; flex-wrap: wrap; gap: 6px; padding: 4px; border: 1px solid #e5e7eb; border-radius: 8px; background: #ffffff;"
    >
      <button
        *ngFor="let option of archiveStatusOptions"
        type="button"
        class="btn btn-sm"
        [ngStyle]="getArchiveStatusButtonStyle(option)"
        [attr.aria-pressed]="archiveStatusFilter === option.value"
        (click)="setArchiveStatusFilter(option.value)"
      >
        <span>{{ option.labelKey | translate }}</span>
        <span [ngStyle]="getArchiveStatusCountStyle(option)">
          {{ getArchiveStatusCount(option) }}
        </span>
      </button>
    </div>
  </div>

  <!-- Filters -->
  <div *ngIf="isManager" class="filters-section">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label translate>EMPLOYEE_NAME</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="employeeNameFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label translate>FORM</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="templateNameFilter"
            (ngModelChange)="onFilterChange()"
            [placeholder]="'SEARCH' | translate" />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label translate>STATUS</label>
          <select
            class="form-control"
            [(ngModel)]="statusFilter"
            (ngModelChange)="onFilterChange()">
            <option *ngFor="let status of statusOptions" [value]="status.value">
              {{ status.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group filter-actions">
          <label>&nbsp;</label>
          <button
            class="btn btn-outline-secondary clear-filters-btn"
            (click)="clearFilters()">
            <i class="fa fa-filter" aria-hidden="true"></i>
            <span translate>CLEAR_FILTERS</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Table -->
  <div class="table-view">
    <p-menu
      #rowActionMenu
      [popup]="true"
      [model]="rowActionItems"
      appendTo="body"
      styleClass="appraisal-row-menu-overlay"
    ></p-menu>

    <p-table
      [value]="appraisals"
      [rows]="pageSize"
      [totalRecords]="totalItems"
      [paginator]="true"
      [pageLinks]="3"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [lazy]="true"
      [loading]="isLoading"
      [(selection)]="selectedAppraisals"
      (onPage)="onPageChange($event)"
      (onSort)="onSort($event)"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="onRowUnselect($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}: {{totalItems}}"
      styleClass="p-datatable-striped">

      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th class="employee-primary-action-column">
            {{ 'MEETING' | translate }}
          </th>
          <th *ngIf="!isManager" class="employee-step-column">
            {{ 'APPRAISAL_NEXT_STEP' | translate }}
          </th>
          <th class="participant-name-column">
            <span class="participant-heading">
              <i
                class="fa participant-heading-icon"
                [ngClass]="participantColumnIconClass"
                aria-hidden="true"
              ></i>
              <span>{{ participantColumnLabelKey | translate }}</span>
            </span>
          </th>
          <th *ngIf="isManager" class="form-column">
            {{ 'FORM' | translate }}
          </th>
          <th pSortableColumn="Title" class="title-column">
            {{ 'TITLE' | translate }}
            <p-sortIcon field="Title"></p-sortIcon>
          </th>
          <th pSortableColumn="Status" class="status-column">
            {{ 'STATUS' | translate }}
            <p-sortIcon field="Status"></p-sortIcon>
          </th>
          <th pSortableColumn="ScheduledDate" class="date-column">
            {{ 'SCHEDULED_DATE' | translate }}
            <p-sortIcon field="ScheduledDate"></p-sortIcon>
          </th>
          <th *ngIf="isManager" class="manager-column">
            {{ 'MANAGER' | translate }}
          </th>
          <th class="actions-column">
            {{ 'ACTIONS' | translate }}
          </th>
        </tr>
      </ng-template>

      <!-- Body -->
      <ng-template pTemplate="body" let-appraisal>
        <tr
          [class.archived-row]="appraisal.IsArchived"
          [class.readonly-row]="appraisal.IsReadOnlyForCurrentUser"
        >
          <td class="employee-primary-action-column" [attr.data-label]="'MEETING' | translate">
            <button
              *ngIf="!isManager"
              type="button"
              class="btn btn-sm employee-primary-action"
              [ngClass]="getEmployeePrimaryActionClass(appraisal)"
              (click)="openPrimaryEmployeeAction(appraisal)"
            >
              <i
                class="fa"
                [ngClass]="getEmployeePrimaryActionIcon(appraisal)"
                aria-hidden="true"
              ></i>
              <span>{{ getEmployeePrimaryActionLabel(appraisal) | translate }}</span>
            </button>
            <button
              *ngIf="isManager"
              type="button"
              class="btn btn-sm employee-primary-action"
              [ngClass]="getManagerPrimaryActionClass(appraisal)"
              (click)="openPrimaryManagerAction(appraisal)"
            >
              <i
                class="fa"
                [ngClass]="getManagerPrimaryActionIcon(appraisal)"
                aria-hidden="true"
              ></i>
              <span>{{ getManagerPrimaryActionLabel(appraisal) | translate }}</span>
            </button>
          </td>
          <td *ngIf="!isManager" class="employee-step-column" [attr.data-label]="'APPRAISAL_NEXT_STEP' | translate">
              <div class="employee-step-cell">
                <span
                  class="badge"
                  [ngClass]="getEmployeeProgressClass(appraisal)"
                  [attr.title]="getEmployeeProgressLabel(appraisal) | translate"
                >
                  {{ getEmployeeProgressLabel(appraisal) | translate }}
                </span>

                <div class="employee-step-hint" [title]="getEmployeeProgressHintKey(appraisal) | translate">
                  {{ getEmployeeProgressHintKey(appraisal) | translate }}
                </div>

                <div
                  *ngIf="getEmployeeProgressTimestamp(appraisal) as progressDate"
                  class="employee-step-meta"
                >
                  <span class="meta-label">
                    {{ getEmployeeProgressTimestampLabelKey(appraisal) | translate }}:
                  </span>
                  <span>{{ progressDate | date: 'dd-MM-yyyy' }}</span>
                </div>

                <div
                  *ngIf="shouldShowEmployeeProgress(appraisal)"
                  class="progress-container"
                >
                  <div class="progress">
                    <div
                      class="progress-bar"
                      [style.width.%]="getEmployeeProgressPercent(appraisal)"
                    ></div>
                  </div>
                  <div class="progress-text">
                    {{ appraisal.EmployeeAnsweredRequiredQuestionCount }}/{{ appraisal.EmployeeRequiredQuestionCount }}
                  </div>
                </div>
              </div>
          </td>
          <td class="participant-name-column" [attr.data-label]="participantColumnLabelKey | translate">
            <div class="employee-info">
              <strong [attr.title]="getParticipantName(appraisal)">
                <i
                  class="fa participant-cell-icon"
                  [ngClass]="participantColumnIconClass"
                  aria-hidden="true"
                ></i>
                <span>{{ getParticipantName(appraisal) }}</span>
              </strong>
              <span
                *ngIf="getParticipantStatusLabelKey(getParticipantStatus(appraisal)) as participantStatusKey"
                class="badge participant-status-badge"
                [ngClass]="getParticipantStatusClass(getParticipantStatus(appraisal))"
              >
                {{ participantStatusKey | translate }}
              </span>
            </div>
          </td>
          <td *ngIf="isManager" class="form-column" [attr.data-label]="'FORM' | translate">
            <div class="template-info" [attr.title]="appraisal.TemplateName || null">
              {{ appraisal.TemplateName }}
            </div>
          </td>
          <td class="title-column" [attr.data-label]="'TITLE' | translate">
            <span class="text-ellipsis" [attr.title]="appraisal.Title || null">{{ appraisal.Title }}</span>
          </td>
          <td class="status-column" [attr.data-label]="'STATUS' | translate">
            <div class="status-badges">
              <span
                class="badge"
                [ngClass]="getDisplayStatusClass(appraisal)"
                [attr.title]="getDisplayStatusText(appraisal) | translate"
              >
                {{ getDisplayStatusText(appraisal) | translate }}
              </span>
              <span
                *ngIf="appraisal.IsReadOnlyForCurrentUser"
                class="badge badge-readonly"
                [attr.title]="'APPRAISAL_READ_ONLY_HISTORY_HINT' | translate"
              >
                {{ 'READ_ONLY' | translate }}
              </span>
            </div>
          </td>
          <td class="date-column" [attr.data-label]="'SCHEDULED_DATE' | translate">
            <span class="text-ellipsis" [attr.title]="appraisal.ScheduledDate ? (appraisal.ScheduledDate | utcDate : 'dd-MM-yyyy') : null">
              {{ appraisal.ScheduledDate ? (appraisal.ScheduledDate | utcDate : 'dd-MM-yyyy') : '—' }}
            </span>
            <small
              *ngIf="appraisal.IsArchived && appraisal.ArchivedOn"
              class="archive-meta"
              [attr.title]="appraisal.ArchivedOn | utcDate : 'dd-MM-yyyy'"
            >
              {{ 'ARCHIVED_ON' | translate }}: {{ appraisal.ArchivedOn | utcDate : 'dd-MM-yyyy' }}
            </small>
          </td>
          <td *ngIf="isManager" class="manager-column" [attr.data-label]="'MANAGER' | translate">
            <div class="participant-inline">
              <span
                class="text-ellipsis"
                [attr.title]="getParticipantDisplayName(appraisal.ManagerName, appraisal.ManagerUserId)"
              >
                {{ getParticipantDisplayName(appraisal.ManagerName, appraisal.ManagerUserId) }}
              </span>
              <span
                *ngIf="getParticipantStatusLabelKey(appraisal.ManagerUserStatus) as managerStatusKey"
                class="badge participant-status-badge"
                [ngClass]="getParticipantStatusClass(appraisal.ManagerUserStatus)"
              >
                {{ managerStatusKey | translate }}
              </span>
            </div>
          </td>
          <td class="actions-column" [attr.data-label]="'ACTIONS' | translate">
            <div class="action-buttons">
              <button
                type="button"
                class="btn btn-sm action-menu-trigger"
                (click)="openRowActionMenu(rowActionMenu, appraisal, $event)"
                [disabled]="isDeletingAppraisal(appraisal.Id)"
                [title]="'ACTIONS' | translate"
                [attr.aria-label]="'ACTIONS' | translate"
                aria-haspopup="true">
                <i
                  [class]="isDeletingAppraisal(appraisal.Id) ? 'fa fa-spinner fa-spin' : 'pi pi-ellipsis-v'"
                  aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Empty message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="isManager ? 8 : 7" class="text-center empty-state-cell">
            <!-- Filtered empty state: no records match the selected status -->
            <div *ngIf="hasActiveStatusFilter" class="empty-state empty-state-filtered">
              <div class="empty-state-icon-shadow">
                <i class="fa fa-search empty-state-icon" aria-hidden="true"></i>
              </div>
              <p class="empty-state-title">
                {{ 'APPRAISAL_NO_RECORDS_MATCHED' | translate }}
              </p>
            </div>

            <!-- Default empty state: no records at all -->
            <div *ngIf="!hasActiveStatusFilter" class="empty-state">
              <i class="fa fa-clipboard empty-state-icon" aria-hidden="true"></i>
              <p class="empty-state-title">
                {{
                  (isManager
                    ? 'APPRAISAL_EMPTY_LIST_MANAGER_TITLE'
                    : 'APPRAISAL_EMPTY_LIST_EMPLOYEE_TITLE') | translate
                }}
              </p>
              <p class="empty-state-body">
                {{
                  (isManager
                    ? 'APPRAISAL_EMPTY_LIST_MANAGER_BODY'
                    : 'APPRAISAL_EMPTY_LIST_EMPLOYEE_BODY') | translate
                }}
              </p>
              <button
                *ngIf="canCreateAppraisal"
                class="btn btn-success appraisal-create-empty-btn"
                (click)="createAppraisal()">
                <i class="fa fa-plus" aria-hidden="true"></i>
                <span translate>CREATE_FIRST_APPRAISAL</span>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
